@defer (on viewport) {
  <app-card>
    <app-card-header title="Suporte, Atendimento e Risco" />
    @if (supportMetricsLoading()) {
      <div class="grid grid-cols-4 gap-4">
        <div class="col-span-1 flex flex-col items-start justify-start gap-4">
          @for (item of [0,1,2,3]; track item) {
            <div class="border-b border-zinc-300 space-y-4 pb-2 w-full">
              <p-skeleton width="4rem" />
              <p-skeleton width="12rem" height="1.5rem" />
              <p-skeleton width="14rem" />
            </div>
          }
        </div>
        <div class="col-span-2">
          <p-skeleton height="27rem" />
        </div>
        <div class="col-span-1 flex flex-col items-start justify-start gap-4">
          @for (item of [0,1,2,3]; track item) {
            <div class="border-b border-zinc-300 space-y-4 pb-2 w-full">
              <p-skeleton width="4rem" />
              <p-skeleton width="12rem" height="1.5rem" />
              <p-skeleton width="14rem" />
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="grid grid-cols-4 gap-4">
        <div class="col-span-1 flex flex-col items-start justify-start gap-4">
          <ng-container [ngTemplateOutlet]="supportMetricsLeft" [ngTemplateOutletContext]="{ inDialog: false }" />
        </div>
        <div class="col-span-2">
          <ng-container [ngTemplateOutlet]="supportTicketsSolved" [ngTemplateOutletContext]="{ inDialog: false }" />
        </div>
        <div class="col-span-1 flex flex-col items-start justify-start gap-4">
          <ng-container [ngTemplateOutlet]="supportMetricsRight" [ngTemplateOutletContext]="{ inDialog: false }" />
        </div>
      </div>
    }
  </app-card>
} @placeholder {
  <app-card>
    <div class="grid grid-cols-4 gap-4">
      <div class="col-span-1 flex flex-col items-start justify-start gap-4">
        @for (item of [0,1,2,3]; track item) {
          <div class="border-b border-zinc-300 space-y-4 pb-2">
            <p-skeleton width="4rem" />
            <p-skeleton width="12rem" height="1.5rem" />
            <p-skeleton width="14rem" />
          </div>
        }
      </div>
      <div class="col-span-2">
        <p-skeleton height="27rem" />
      </div>
      <div class="col-span-1 flex flex-col items-start justify-start gap-4">
        @for (item of [0,1,2,3]; track item) {
          <div class="border-b border-zinc-300 space-y-4 pb-2">
            <p-skeleton width="4rem" />
            <p-skeleton width="12rem" height="1.5rem" />
            <p-skeleton width="14rem" />
          </div>
        }
      </div>
    </div>
  </app-card>
}

<p-dialog
  [(visible)]="dialogVisible"
  [maximizable]="true"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '60rem', minHeight: '32rem' }"
>
  <ng-template pTemplate="header">
    <div class="text-zinc-900 text-xl font-semibold">{{ dialogTitle() }}</div>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="selectedDialogChart()"
    [ngTemplateOutletContext]="{ inDialog: true }"
  ></ng-container>
</p-dialog>

<ng-template #supportMetricsLeft let-inDialog="inDialog">
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">Chamados Resolvidos</div>
    <div class="text-xl text-zinc-900 font-semibold">
      {{ supportMetricsData()?.chamados_resolvidos?.value }}
      <span class="text-zinc-400 text-sm font-normal"> de {{ supportMetricsData()?.chamados_resolvidos?.total }}</span>
    </div>
    <div class="text-sm text-zinc-500">
      @if ((supportMetricsData()?.chamados_resolvidos?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((supportMetricsData()?.chamados_resolvidos?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': (supportMetricsData()?.chamados_resolvidos?.change_percentage || 0) > 0,
        'text-rose-600': (supportMetricsData()?.chamados_resolvidos?.change_percentage || 0) < 0
      }">{{ supportMetricsData()?.chamados_resolvidos?.change_percentage || 0 }}%</span>
    </div>
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">Média Diária</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ supportMetricsData()?.media_diaria?.value }}</div>
    <div class="text-sm text-zinc-500">
      @if ((supportMetricsData()?.media_diaria?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((supportMetricsData()?.media_diaria?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': (supportMetricsData()?.media_diaria?.change_percentage || 0) > 0,
        'text-rose-600': (supportMetricsData()?.media_diaria?.change_percentage || 0) < 0
      }">{{ supportMetricsData()?.media_diaria?.change_percentage || 0 }}%</span>
    </div>
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">Saques Aprovados (Últimas 24h)</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ supportMetricsData()?.saques_aprovados_24h?.value }}</div>
    <div class="text-sm text-zinc-500">
      @if ((supportMetricsData()?.saques_aprovados_24h?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((supportMetricsData()?.saques_aprovados_24h?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': (supportMetricsData()?.saques_aprovados_24h?.change_percentage || 0) > 0,
        'text-rose-600': (supportMetricsData()?.saques_aprovados_24h?.change_percentage || 0) < 0
      }">{{ supportMetricsData()?.saques_aprovados_24h?.change_percentage || 0 }}%</span>
    </div>
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">Média de Saques Aprovados (Mês)</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ supportMetricsData()?.media_saques_aprovados_mes?.value }}</div>
    <div class="text-sm text-zinc-500">
      @if ((supportMetricsData()?.media_saques_aprovados_mes?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((supportMetricsData()?.media_saques_aprovados_mes?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': (supportMetricsData()?.media_saques_aprovados_mes?.change_percentage || 0) > 0,
        'text-rose-600': (supportMetricsData()?.media_saques_aprovados_mes?.change_percentage || 0) < 0
      }">{{ supportMetricsData()?.media_saques_aprovados_mes?.change_percentage || 0 }}%</span>
    </div>
  </div>
</ng-template>

<ng-template #supportMetricsRight let-inDialog="inDialog">
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">TMR (Tempo Médio de Resposta)</div>
    <div class="text-xl text-zinc-900 font-semibold">---</div>
    <div class="text-sm text-zinc-500">
      <span>--%</span>
    </div>
    <!-- <div class="text-xl text-zinc-900 font-semibold">{{ 4 }}m</div>
    <div class="text-sm text-zinc-500">
      @if (20 > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if (20 < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': 20 > 0,
        'text-rose-600': 20 < 0
      }">{{ 20 }}%</span>
    </div> -->
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">TTR</div>
    <div class="text-xl text-zinc-900 font-semibold">---</div>
    <div class="text-sm text-zinc-500">
      <span>--%</span>
    </div>
    <!-- <div class="text-xl text-zinc-900 font-semibold">{{ 4 }}m</div>
    <div class="text-sm text-zinc-500">
      @if (20 > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if (20 < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': 20 > 0,
        'text-rose-600': 20 < 0
      }">{{ 20 }}%</span>
    </div> -->
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">TMA dos Saques (Tempo Médio de Aprovação)</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ supportMetricsData()?.tma?.formatted }}</div>
    <!-- <div class="text-sm text-zinc-500">
      @if (20 > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if (20 < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': 20 > 0,
        'text-rose-600': 20 < 0
      }">{{ 20 }}%</span>
    </div> -->
    <div class="text-sm text-zinc-500">
      <span>--%</span>
    </div>
  </div>
  <div class="w-full border-b border-zinc-300 space-y-2 pb-2">
    <div class="text-sm text-zinc-500">Movimentação Financeira</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ supportMetricsData()?.movimentacao_financeira?.value | currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((supportMetricsData()?.movimentacao_financeira?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((supportMetricsData()?.movimentacao_financeira?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': (supportMetricsData()?.movimentacao_financeira?.change_percentage || 0) > 0,
        'text-rose-600': (supportMetricsData()?.movimentacao_financeira?.change_percentage || 0) < 0
      }">{{ supportMetricsData()?.movimentacao_financeira?.change_percentage || 0 }}%</span>
    </div>
  </div>
</ng-template>

<ng-template #supportTicketsSolved let-inDialog="inDialog">
  @if (supportTicketsSolvedLoading() && !supportTicketsSolvedChartData()) {
    <div class="w-full h-100 flex items-center justify-center">
      <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
    </div>
  } @else if (supportTicketsSolvedChartData()?.datasets.length) {
    <div class="w-full flex flex-wrap items-center justify-between">
      <div class="text-sm text-zinc-500 mb-2">Chamados Resolvidos por dia</div>
      <div>
        @if (!inDialog) {
          <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(supportTicketsSolved, 'Diário')"></i>
        }
      </div>
    </div>
    <p-chart
      id="supportTicketsSolvedChart"
      #supportTicketsSolvedChart
      type="line"
      [data]="supportTicketsSolvedChartData()"
      [options]="supportTicketsSolvedOptions()"
      class="w-full h-100"
    />
  } @else {
    <app-empty-chart />
  }
</ng-template>
